import UtmRq from '@domain/rq/common/UtmRq';
import { SOCIAL_ACCOUNT_TYPE } from '@domain/constant/socicalType';
import { GenderType } from '@domain/constant/genderType';
import TextFormat from '@utils/text/format';

export default class JoinRq {
  basic: BasicInfo;
  account: AccountInfo;
  terms: TermsInfo;
  social: SocialInfo;
  mobileToken?: string; // 회원가입 SMS 인증 토큰 정보
  utm?: string; //Google UTM 정보
  identificationToken: string;

  constructor(vo: JoinData) {
    this.basic = new BasicInfo(vo);
    this.account = new AccountInfo(vo);
    this.terms = new TermsInfo(vo);
    this.social = new SocialInfo(vo);
    if (vo.token) this.mobileToken = vo.token;
    this.utm = new UtmRq(vo).getQueryString();
    this.identificationToken = vo.identificationToken;
  }
}
class BasicInfo {
  name: string;
  birthDate: string;
  genderFlag: GenderType;
  mobile: string;
  countryCode: string;

  constructor(vo: JoinData) {
    this.name = vo.name;
    this.birthDate = TextFormat.birthDate(vo.birthDate, '-');
    this.genderFlag = vo.genderFlag;
    this.mobile = `${vo.mobile}`?.replace(/[^0-9]/g, '');
    this.countryCode = vo.countryCode;
  }
}

class AccountInfo {
  id: string;
  password: string;
  email: string;

  constructor(vo: JoinData) {
    this.id = vo.userId;
    this.password = vo.password;
    this.email = vo.email;
  }
}

class SocialInfo {
  openId: string | null; // 소셜 인증 아이디
  openIdProvider: SOCIAL_ACCOUNT_TYPE | null; // 소셜 인증 제공자

  constructor(vo: JoinData) {
    this.openId = vo.openId || null;
    this.openIdProvider = vo.openIdProvider || null;
  }
}

class TermsInfo {
  agreeTermsOfServiceYn: boolean; // 서비스이용약관 동의
  agreePrivacyCollectionYn: boolean; // 개인정보수집이용안내 동의
  marketingConsentYn: boolean; // 마케팅정보수신 동의
  marketingSmsConsentYn: boolean; // 마케팅정보수신 SMS 동의
  marketingEmailConsentYn: boolean; // 마케팅정보수신 이메일 동의

  constructor(vo: JoinData) {
    this.agreeTermsOfServiceYn = vo.agreeTermsOfServiceYn;
    this.agreePrivacyCollectionYn = vo.agreePrivacyCollectionYn;
    this.marketingConsentYn = vo.marketingEmailConsentYn || vo.marketingSmsConsentYn;
    this.marketingSmsConsentYn = vo.marketingSmsConsentYn;
    this.marketingEmailConsentYn = vo.marketingEmailConsentYn;
  }
}

export interface JoinData {
  name: string;
  birthDate: string;
  genderFlag: GenderType;
  mobile: string | number;
  countryCode: string;

  userId: string;
  password: string;
  email: string;

  agreeTermsOfServiceYn: boolean; // 서비스
  agreePrivacyCollectionYn: boolean; //개인정보
  marketingConsentYn: boolean; //마케팅
  marketingSmsConsentYn: boolean; //sms
  marketingEmailConsentYn: boolean; //email

  //소셜 관련
  openId: string | null;
  openIdProvider: SOCIAL_ACCOUNT_TYPE | null;

  token: string;
  //아이핀 인증 토큰
  identificationToken: string;
}
